import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractBaseSection } from './abstract-base-section';
import { SpecificationEmbodimentOutlineService } from '../specification-embodiment-outline-service';
import { StreamStatus } from '@/services/sse-ps-http/enums';
import { SpecificationContentType } from '../../enums';

@injectable()
export class EmbodimentConclusionSection extends AbstractBaseSection {
    readonly contentType = SpecificationContentType.EmbodimentConclusion;

    constructor(
        @inject(SpecificationEmbodimentOutlineService)
        private readonly _outlineService: SpecificationEmbodimentOutlineService,
    ) {
        super();
    }

    async generate(regenerate?: boolean) {
        this.updateContent({
            type: this.contentType,
            status: StreamStatus.FINISH,
            content: this._outlineService.model.modelData.conclusion?.text || '',
        });
    }

    stop() {
        this._outlineService.abort();
    }
}
